import ACTIONS from '@/storeActions';
import Vue from 'vue';
import ky from 'ky';
import FileSaver from 'file-saver';

const { apiUrl } = window;

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.apiRequest) {
      this.$apiRequest = options.apiRequest;
    } else if (options.parent && options.parent.$apiRequest) {
      this.$apiRequest = options.parent.$apiRequest;
    }
  },
});

class ApiRequest {
  constructor(store, http, i18n) {
    this.store = store;
    this.http = http;
    this.i18n = i18n;
  }

  handleError(err) {
    //console.log('request error', err);
    if (err && err.body && err.body.errorMessage) {
      this.store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.i18n.t(err.body), color: 'error' });
    } else if (err && (err.status === 0 || err.status === 500)) {
      this.store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.i18n.t('Errors.generic500'), color: 'error' });
    } else if (err && err.body && err.body.errors) {
      const keys = Object.keys(err.body.errors);
      if (keys && keys[0]) {
        this.store.dispatch(ACTIONS.SET_SNACKBAR, { text: this.i18n.t(`Errors.Validation.${keys[0]}`), color: 'error' });
      }
    }
  }

  post(url, body) {
    const self = this;
    const token = self.store.getters.bearerToken();
    Vue.http.headers.common.Authorization = `Bearer ${token}`; // todo: diesen Wert nach dem Store init zentral setzen

    this.store.dispatch(ACTIONS.SET_IS_LOADING, true);

    return new Promise(((resolve, reject) => {
      self.http
        .post(apiUrl + url, body)
        .then((response) => {
          if (response && response.ok && response.body) {
            resolve(response.body);
          } else {
            reject(response.body);
          }
        })
        .catch((error) => {
          this.handleError(error);
          reject(error.body);
        })
        .finally(() => {
          this.store.dispatch(ACTIONS.SET_IS_LOADING, false);
        });
    }));
  }

  put(url, body) {
    const self = this;
    const token = self.store.getters.bearerToken();
    Vue.http.headers.common.Authorization = `Bearer ${token}`; // todo: diesen Wert nach dem Store init zentral setzen

    this.store.dispatch(ACTIONS.SET_IS_LOADING, true);

    return new Promise(((resolve, reject) => {
      self.http
        .put(apiUrl + url, body)
        .then((response) => {
          if (response && response.ok && response.body) {
            resolve(response.body);
          } else {
            reject(response.body);
          }
        })
        .catch((error) => {
          this.handleError(error);
          reject(error.body);
        })
        .finally(() => {
          this.store.dispatch(ACTIONS.SET_IS_LOADING, false);
        });
    }));
  }

  delete(url, body) {
    const self = this;
    const token = self.store.getters.bearerToken();
    Vue.http.headers.common.Authorization = `Bearer ${token}`; // todo: diesen Wert nach dem Store init zentral setzen

    this.store.dispatch(ACTIONS.SET_IS_LOADING, true);

    return new Promise(((resolve, reject) => {
      self.http
        .delete(apiUrl + url, body)
        .then((response) => {
          if (response && response.ok && response.body) {
            resolve(response.body);
          } else {
            reject(response.body);
          }
        })
        .catch((error) => {
          this.handleError(error);
          reject(error.body);
        })
        .finally(() => {
          this.store.dispatch(ACTIONS.SET_IS_LOADING, false);
        });
    }));
  }

  getBlob(url, query) {
    const self = this;
    const token = self.store.getters.bearerToken();
    // console.log("GET BLOB", url, query, token);
    // this.store.dispatch('setIsLoading', true);
    return new Promise((async (resolve, reject) => {
      const val = await ky.get(`${apiUrl}${url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        stream: true,
      }).blob().catch(reject)
        //.blob().catch(reject).finally( () => { /* this.store.dispatch('setIsLoading', false); */ });
      resolve(val);
    }));
  }

  getBlobByPost(url, body) {
    const self = this;
    const token = self.store.getters.bearerToken();
    return new Promise((async (resolve, reject) => {
      const val = await ky.post(`${apiUrl}${url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        stream: true,
        json: body
      });
      const blobbed = await val.blob();
      resolve(blobbed);
    }))
  }

  getFile(url, fileName) {
    const self = this;
    return new Promise((async (resolve, reject) => {
      const result = await self.getBlob(url)
      FileSaver.saveAs(URL.createObjectURL(result), fileName);
      resolve();
    }));
  }

  get(url, query) {
    const self = this;
    const token = self.store.getters.bearerToken();
    Vue.http.headers.common.Authorization = `Bearer ${token}`;

    this.store.dispatch(ACTIONS.SET_IS_LOADING, true);

    return new Promise(((resolve, reject) => {
      self.http
        .get(apiUrl + url, { params: query })
        .then((response) => {
          if (response && response.ok && response.body) {
            resolve(response.body);
          } else {
            reject(response.body);
          }
        })
        .catch((error) => {
          this.handleError(error);
          reject(error.body);
        })
        .finally(() => {
          this.store.dispatch(ACTIONS.SET_IS_LOADING, false);
        });
    }));
  }
}

export default ApiRequest;
